<template>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <div class="trip-login-wrap">
          <h3>{{ t('resetPasswordTitle') }}</h3>

          <div class="trip-border-content">
            <p>{{ t('resetPasswordPageEnterNew') }}</p>
          </div>

          <form @submit.prevent="handleResetPassword">
            <div class="trip-login-field">
              <b-form-input
                :dir="$store.getters['language/getCurrentLanguage'] === 'he' ? 'rtl' : 'ltr'"
                v-model="password"
                autocapitalize="none"
                type="password"
                :placeholder="t('resetPasswordPageNewPassword')"
                class="log_in_medium"
                required>
              </b-form-input>
            </div>

            <div class="trip-login-field">
              <b-form-input
                :dir="$store.getters['language/getCurrentLanguage'] === 'he' ? 'rtl' : 'ltr'"
                v-model="confirmPassword"
                autocapitalize="none"
                type="password"
                :placeholder="t('resetPasswordPageConfirmPassword')"
                class="log_in_medium"
                required>
              </b-form-input>
            </div>
            
            <button 
              id="trip-login-btn"
              type="submit"
              :disabled="isLoading">
              <b-spinner small v-if="isLoading"></b-spinner>
              <span v-else>{{ t('resetPasswordPageUpdate') }}</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { translationMixin } from '@/mixins/translationMixin';
import { INTERNAL_HOME_PATH } from '@/common/appHome';

export default {
  name: 'ResetPasswordPage',
  mixins: [translationMixin],
  data() {
    return {
      password: '',
      confirmPassword: '',
      isLoading: false,
      token: ''
    };
  },
  methods: {
    ...mapActions(['resetPassword']),
    
    async handleResetPassword() {
      if (!this.validatePasswords()) {
        return;
      }
      
      this.isLoading = true;
      const success = await this.resetPassword({
        token: this.token,
        newPassword: this.password
      });
      this.isLoading = false;

      if (success) {
        // Clear form
        this.password = '';
        this.confirmPassword = '';
      }
    },
    
    validatePasswords() {
      if (this.password.length < 6) {
        this.$store.dispatch('showModalWithParameters', {
          errorNumber: 'password_too_short',
          type: 'textConverter'
        });
        return false;
      }
      
      if (this.password !== this.confirmPassword) {
        this.$store.dispatch('showModalWithParameters', {
          errorNumber: 'passwords_dont_match',
          type: 'textConverter'
        });
        return false;
      }
      
      return true;
    }
  },
  created() {
    // Get token from URL query parameter
    this.token = this.$route.query.token;
    if (!this.token) {
      this.$store.dispatch('showModalWithParameters', {
        errorNumber: 'invalid_reset_token',
        type: 'textConverter'
      });
      this.$router.push(INTERNAL_HOME_PATH);
    }
  }
};
</script>

<style scoped>
.modal-dialog {
  max-width: 310px;
  margin: 1.75rem auto !important;
  margin-top: 10% !important;
}

.modal-content {
  background: #FFFFFF;
  box-shadow: 4px 4px 4px rgb(0 0 0 / 10%);
  border-radius: 25px;
  border: none;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 45px 55px;
  border: none;
}

.trip-login-wrap {
  text-align: center;
}

.trip-login-wrap h3 {
  font-weight: 800;
  font-size: 18px;
  line-height: 21px;
  color: #2E2E3A;
  margin-bottom: 15px;
  text-align: center;
}

.trip-border-content {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 12px;
  position: relative;
}

.trip-border-content p {
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #2E2E3A;
  text-align: center;
  position: relative;
  z-index: 1;
  display: inline-block;
  background-color: #fff;
  padding: 0 10px;
}

.trip-border-content::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 1px;
  background-color: #2E2E3A;
  z-index: 0;
}

.trip-login-field {
  margin-bottom: 10px;
}

.trip-login-field input {
  height: 30px;
  width: 100%;
  text-align: start;
  border: 1px solid #C1C0C0;
  border-radius: 22px;
  font-size: 12px;
  line-height: 14px;
  padding: 5px 15px !important;
  color: black;
}

button#trip-login-btn {
  width: 100%;
  height: 30px;
  background: #34D0B6;
  border-radius: 22px;
  border: none;
  font-weight: 500;
  font-size: 12px;
  color: white;
  margin-top: 15px;
}

button#trip-login-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}
</style> 